import type { ScannerHandle, StartScannerOptions } from './types'

export async function startZxingScanner({
    videoElement,
    cameraId,
    onDetected
}: StartScannerOptions): Promise<ScannerHandle> {
    const { BrowserMultiFormatReader } = await import('@zxing/browser')
    const reader = new BrowserMultiFormatReader()

    const deviceId = cameraId && cameraId !== '' && cameraId !== '-' ? cameraId : undefined

    const controls = await reader.decodeFromVideoDevice(deviceId, videoElement, result => {
        if (result) onDetected(result.getText())
    })

    return {
        stop: () => {
            controls.stop()
        }
    }
}
